import {Injectable} from '@angular/core';
import {RestNewsService} from '@app/core/api/news.service';
import {RestUserService} from '@app/core/api/rest.user.service';
import {ChangelogSeenService} from '@app/core/state/changelogseen/changelogseen.service';
import {HistoryService} from '@app/core/state/history/history.service';
import {KontakteService} from '@app/core/state/kontakte';
import {PersistentTabService} from '@app/core/state/persistent-tab/persistent-tab.service';
import {SearchResultHistoryService} from '@app/core/state/search-result-history/search-result-history.service';
import {PayloadUtil} from '@app/core/util/payload.util';
import {Benutzer} from '@pezi/entities';
import {Observable, of} from 'rxjs';
import {filter, map, tap} from 'rxjs/operators';
import {SessionStore} from './session.store';
import {setProps} from "@ngneat/elf";
import {UserSettingsService} from "@app/core/state/user-settings";

@Injectable({providedIn: 'root'})
export class SessionService {


  constructor(private sessionStore: SessionStore,
              private userService: RestUserService, private historyService: HistoryService<any>,
              private kontakteService: KontakteService, private persistentTabService: PersistentTabService,
              private changelogSeenService: ChangelogSeenService, private searchResultHistoryService: SearchResultHistoryService,
              private newsService: RestNewsService, private settingsService: UserSettingsService) {
  }

  setLoggedInUser(): Observable<Benutzer> {
    return this.userService.getLoggedInUser()
      .pipe(tap((user: Benutzer) => this.sessionStore.data.update(setProps({loggedInUser: user}))));
  }

  getLoggedInUser(): Benutzer {
    return this.sessionStore.data.getValue().loggedInUser;
  }


  getStaticServerUrl(): Observable<string> {
    if (this.sessionStore.data.getValue()?.staticServerUrl) {
      return of(this.sessionStore.data.getValue().staticServerUrl)
    }
    return this.newsService.getStaticServerUrl().pipe(
      filter(payload => PayloadUtil.checkPayload(payload)),
      map(payload => payload.data),
      tap(staticUrl => this.sessionStore.data.update(setProps({staticServerUrl: staticUrl}))
      )
    );
  }

  async logout(): Promise<boolean> {
    const logoutSuccessful = await this.userService.logoutUser();
    this.clearAllTempStores();
    return logoutSuccessful;
  }

  clearSessionStore() {
    this.sessionStore.data.reset();
  }

  clearAllTempStores(): void {
    this.historyService.clearHistoryStore();
    this.kontakteService.clearKontakteStore();
    this.persistentTabService.clearPersistentTabStore();
    this.changelogSeenService.clearChangelogSeenStore();
    this.searchResultHistoryService.clearSearchResultHistoryStore();
    this.settingsService.clearSettingsStore();

    this.clearSessionStore();
  }

  public deletePwaCachesAndReload() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => registrations.forEach((registration) => {
          registration.unregister()
            .then((r) => {
              caches.keys()
                .then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))));
            }, (e) => {
              console.error('registration.unregister(): ', e);
            });
        }))
        .then(r => window.location.reload());
    } else {
      window.location.reload();
    }
  }
}
